import {
  ESPage,
  RefetchOnError,
  toPayloadDateBroker,
  useDocumentTitle,
} from '@energy-stacks/shared';
import { useTranslation } from 'react-i18next';
import { Dashboard } from './Dashboard';
import { DashboardSkeleton } from './DashboardSkeleton';
import { useGetSessionNumberAndConsumptionSlicesQuery } from '@energy-stacks/broker/feature-dashboard-data';

export const DashboardPage = () => {
  const { t } = useTranslation('dashboard');
  useDocumentTitle(t('title'));

  const now = new Date();
  const startOfToday = new Date(
    now.getFullYear(),
    now.getMonth(),
    now.getDate()
  );

  const { isLoading, isSuccess, isError, refetch } =
    useGetSessionNumberAndConsumptionSlicesQuery({
      from: toPayloadDateBroker(startOfToday),
      to: toPayloadDateBroker(now),
    });

  return (
    <ESPage title={t('title')}>
      {isLoading ? <DashboardSkeleton /> : null}
      {isError ? <RefetchOnError onRefetch={refetch} /> : null}
      {isSuccess ? <Dashboard /> : null}
    </ESPage>
  );
};
